import { ELEMENT_BLOCKQUOTE, ELEMENT_CODE_BLOCK, ELEMENT_TD, } from '@udecode/plate';
const softBreakPlugin = {
    options: {
        rules: [
            { hotkey: 'shift+enter' },
            {
                hotkey: 'enter',
                query: {
                    allow: [ELEMENT_CODE_BLOCK, ELEMENT_BLOCKQUOTE, ELEMENT_TD],
                },
            },
        ],
    },
};
export default softBreakPlugin;
//# sourceMappingURL=softBreakPlugin.js.map